/* MarieOdile — herstel na terug-navigatie uit de checkout.

   De browser zet de pagina terug uit de back/forward-cache. Die DOM is de
   momentopname van vóór het toevoegen: het winkelwagenbolletje en de lade
   staan er nog leeg bij terwijl de winkelwagen op de server wél gevuld is,
   en knoppen die vlak voor de doorverwijzing op "bezig" zijn gezet blijven
   uitgeschakeld hangen.

   Aanpak: knoppen altijd losmaken, en het echte aantal uit /cart.js
   vergelijken met het aantal dat bij het renderen in de pagina is gezet.
   Wijkt dat af, dan is elke poging tot gedeeltelijk bijwerken giswerk over
   de opmaak van een vreemd thema; één herlading zet alles in één keer goed
   en gebeurt alleen na een echte terugnavigatie. */
(function () {
  'use strict';

  function maakKnoppenVrij() {
    var knoppen = document.querySelectorAll(
      'button[type=submit], [data-mo-atc], [data-mo-sticky-atc], [name=add], .btn--add-to-cart'
    );
    [].forEach.call(knoppen, function (b) {
      if (b.dataset.moSoldout === '1') return;   /* uitverkocht blijft uit */
      b.disabled = false;
      b.removeAttribute('aria-busy');
      b.classList.remove('is-loading', 'loading', 'btn--loading');
    });
    [].forEach.call(document.querySelectorAll('.loader, .spinner'), function (s) {
      s.classList.remove('is-active');
    });
  }

  window.addEventListener('pageshow', function (e) {
    /* Ook zonder e.persisted: een terugnavigatie kan de pagina ook uit de
       gewone HTTP-cache halen, en dan is de opmaak net zo oud terwijl
       persisted false blijft. De controle kost één /cart.js. */
    if (e.persisted) maakKnoppenVrij();

    var gerenderd = typeof window.__moCartCount === 'number' ? window.__moCartCount : null;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var echt = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (echt === null) return;
        var bolletje = !!document.querySelector('.cart__toggle--has-items');
        var scheef = (gerenderd !== null && echt !== gerenderd) || (echt > 0) !== bolletje;
        if (!scheef) return;
        /* Eén herlading per stand van de winkelwagen. Zou de verse pagina om
           welke reden dan ook weer een ander aantal tonen, dan blijft het bij
           die ene keer in plaats van een lus. */
        var sleutel = 'moCartReload';
        try {
          if (sessionStorage.getItem(sleutel) === String(echt)) return;
          sessionStorage.setItem(sleutel, String(echt));
        } catch (err) { /* privémodus: dan zonder rem */ }
        window.location.reload();
      })
      .catch(function () { /* offline of geblokkeerd: laat de pagina staan */ });
  });
}());
